module.exports = __webpack_public_path__ + "img/intro-4.d5af8613.png";